<template>
  <div>
    <div class="form-row">
      <div class="form-field">
        <label>
          <select v-model="newFace.DATA.TYPE" >
            <option value="Контрагент">Контрагент</option>
            <option value="Не контрагент">Не контрагент</option>
          </select>
        </label>
      </div>
      <div class="form-field">
        <label>
          Фамилия:
        <input
          type="text"
          v-model="newFace.DATA.LAST_NAME"
        />
        </label>
      </div>
      <div class="form-field">
        <label>
          Имя:
          <input
            type="text"
            v-model="newFace.DATA.FIRST_NAME"
          />
        </label>
      </div>
      <div class="form-field">
        <label>
          Отчество:
          <input
            type="text"
            v-model="newFace.DATA.MIDDLE_NAME"
          />
        </label>
      </div>
        <div class="form-field" v-show="newFace.DATA.TYPE=='Контрагент'">
          <label>
            Номер паспорта:
            <input
              type="text"
              v-model="newFace.DATA.PASSPORT_NUMBER"
            />
          </label>
        </div>
        <div class="form-field"  v-show="newFace.DATA.TYPE=='Контрагент'">
          <label>
            Серия:
            <input
              type="text"
              v-model="newFace.DATA.SERIES"
            />
          </label>
        </div>
        <div class="form-field"  v-show="newFace.DATA.TYPE=='Контрагент'">
          <label>
            Кем выдан:
            <input
              type="text"
              v-model="newFace.DATA.WHO"
            />
          </label>
        </div>
        <div class="form-field"  v-show="newFace.DATA.TYPE=='Контрагент'">
          <label>
            Дата выдачи:
            <input
              type="text"
              v-model="newFace.DATA.WHEN"
            />
          </label>
        </div>
        <div class="form-field"  v-show="newFace.DATA.TYPE=='Контрагент'">
          <label>
            Код подразделения:
            <input
              type="text"
              v-model="newFace.DATA.CODE"
            />
          </label>
        </div>
        <div class="form-field"  v-show="newFace.DATA.TYPE=='Контрагент'">
          <label>
            Дата рождения:
            <input
              type="text"
              v-model="newFace.DATA.DATE_OF_BIRTH"
            />
          </label>
        </div>
        <div class="form-field"  v-show="newFace.DATA.TYPE=='Контрагент'">
          <label>
            Адрес регистрации:
            <input
              type="text"
              v-model="newFace.DATA.ADDRESS"
            />
          </label>
        </div>
        <div class="form-field"  v-show="newFace.DATA.TYPE=='Контрагент'">
          <label>
            ID контрагента:
            <input
              type="text"
              v-model="newFace.DATA.CONTR_ID"
            />
          </label>
        </div>
      <div class="form-field">
        <label>
          Роль:
          <select v-model="newFace.DATA.ROLE">
            <option value="Собственник" v-show="newFace.DATA.TYPE=='Контрагент'">Собственник</option>
            <option value="Представитель" v-show="newFace.DATA.TYPE=='Контрагент'">Представитель</option>
            <option value="Близкий" v-show="newFace.DATA.TYPE!='Контрагент'">Близкий</option>
            <option value="Контрагент клиента" v-show="newFace.DATA.TYPE!='Контрагент'">Контрагент клиента</option>
          </select>
        </label>
      </div>
      <div class="form-field" v-show="newFace.DATA.ROLE=='Представитель'">
        <label>
          Договоры:
          <select v-model="newFace.DATA.DOCS">
            <option v-for="(document, key) in documents" :key="key" :value="document.ID" >{{document.NAME}}</option>
          </select>
        </label>
      </div>
      <div class="form-field">
        <label>
          Номер телефона:
          <input
            type="text"
            v-model="newFace.DATA.PHONE"
          />
        </label>
      </div>
      <div class="form-field">
        <label>
          Почта:
          <input
            type="text"
            v-model="newFace.DATA.EMAIL"
          />
        </label>
      </div>
      <div class="form-field">
        <button @click="newFace.DATA.CONTACTS.push({})">Добавить контакты</button>
      </div>
      <template v-for="(contact, key) in newFace.DATA.CONTACTS" >
        <div class="form-field">
          <label>
            Номер телефона:
            <input
              type="text"
              v-model="contact.PHONE"
            />
          </label>
        </div>
        <div class="form-field">
          <label>
            Почта:
            <input
              type="text"
              v-model="contact.EMAIL"
            />
          </label>
        </div>
      </template>
      <div class="form-field">
        <button @click="sendUserData">Добавить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "addFace",
  props: ["plot"],
  data() {
    return {
      url: config.backend_url,
      info: null,
      newFace: {
        DATA: {
          CONTACTS: []
        }
      },
      idPlot: this.plot,
      features: [],
      services: [],
      documents: []
    };
  },
  computed: {},
  methods: {
    sendUserData: function() {
      let self = this;
      this.newFace.plot_id = this.idPlot;
      this.newFace.phone = this.newFace.DATA.PHONE;
      this.newFace.email = this.newFace.DATA.EMAIL;
      this.newFace.ADDRESS = this.newFace.DATA.ADDRESS;
      this.newFace.FIO = this.newFace.DATA.LAST_NAME+' '+this.newFace.DATA.FIRST_NAME+' '+this.newFace.DATA.MIDDLE_NAME;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "users/add-face/",
          data: this.newFace,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (data) {
            self.info = "Лицо добавлено";
            self.$emit("face-add");
          }
        });
    },
    getServicesList: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "services/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.services = data;
          }
        });
    },
    getPlotData: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-documents/",
          data: { ID: this.idPlot },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            console.log(data);
            this.documents = data;
          }
        });
    }
  },
  created() {
    this.getPlotData();
    this.getServicesList();
  }
};
</script>
